import { Module, ModuleRegistryProvider } from "@com.mgmtp.a12.client/client-core/lib/core/application";
import { StoreFactories } from "@com.mgmtp.a12.client/client-core/lib/core/store";
import { UaaActions } from "@com.mgmtp.a12.uaa/uaa-authentication-client";

import pageModule from "../app/page/index";

import appmodelModule from "./appmodel";
import archiveModule from "./archive";
import changelogModule from "./changelog";
import dashboardModule from "./dashboard";
import eldoradoArchivalModule from "./eldoradoArchival";
import emailModule from "./email";
import exportModule from "./export";
import focusHandlingFormEngineModule from "./focusHandling";
import fristenModule from "./fristen";
import gebuehrenforderungModule from "./gebuehrenforderung";
import zahlungsvorgangEpayblModule from "./zahlungsvorgangEpaybl";
import xFinanzDateiModule from "./xFinanzDatei";
import modul11InformationenNachfordernModule from "./informationenNachfordern";
import linksModule from "./links";
import xmlEinlesenModule from "./mapper/xml-einlesen";
import modul16pdfGenerierenModule from "./pdfGenerieren";
import processFormEngineModule from "./processFormEngine";
import processNotificationsModule from "./processNotifications";
import processOverviewModule from "./processOverview";
import stammdatenModule from "./stammdaten";
import textbausteineModule from "./textbausteine";
import wiedervorlageModule from "./wiedervorlagen";
import openregisterUpsertModule from "./openregisterUpsert";
import openregisterSelectionModule from "./openregisterSelection";
import workflowsModule from "./workflows";
import contactDataModule from "./contactData";
import invitationModule from "./invitation";
import deepLinkingModule from "./deepLinking";

export const ALL_MODULES = [
	deepLinkingModule(),
	workflowsModule(),
	appmodelModule(),
	processOverviewModule(),
	processFormEngineModule(),
	modul11InformationenNachfordernModule(),
	xmlEinlesenModule(),
	modul16pdfGenerierenModule(),
	dashboardModule(),
	textbausteineModule(),
	wiedervorlageModule(),
	stammdatenModule(),
	focusHandlingFormEngineModule(),
	emailModule(),
	pageModule(),
	archiveModule(),
	exportModule(),
	fristenModule(),
	changelogModule(),
	eldoradoArchivalModule(),
	linksModule(),
	processNotificationsModule(),
	gebuehrenforderungModule(),
	zahlungsvorgangEpayblModule(),
	xFinanzDateiModule(),
	contactDataModule(),
	invitationModule(),
	openregisterUpsertModule(),
	openregisterSelectionModule()
];
const moduleRegistry = ModuleRegistryProvider.getInstance();

/**
 * Get all modules.
 */
export const getAllModules = (): Module[] => {
	return ALL_MODULES;
};

/**
 * On login, registers all modules that current user has access to.
 */
export const registerModulesOnLoginMiddleware = StoreFactories.createMiddleware((api, next, action) => {
	if (UaaActions.loggedIn.match(action)) {
		getAllModules()
			// Verhindert doppelte Registrierung
			.filter(m => moduleRegistry.getAllModules().every(({ id }) => id !== m.id))
			.forEach(m => moduleRegistry.addModule(m));
	}

	return next(action);
});

/**
 * On logout, unregisters all modules.
 */
export const unregisterModulesOnLogoutMiddleware = StoreFactories.createMiddleware((api, next, action) => {
	// The logout action has to be processed first so that any existing activities are removed first
	const result = next(action);

	if (UaaActions.loggedOut.match(action)) {
		moduleRegistry
			.getAllModules()
			.map(({ id }) => id)
			.forEach(id => moduleRegistry.removeModuleById(id));
	}

	return result;
});
